/**
 * Load agent context from session storage
 * @param {string} key - Storage key
 * @param {object} defaultValue - Default value if nothing stored
 * @param {boolean} showLogs - Whether to show console logs
 * @returns {object} Stored data or default value
 */
export const loadFromSessionStorage = (key, defaultValue, showLogs = false) => {
  try {
    const stored = sessionStorage.getItem(key);
    if (stored) {
      const parsed = JSON.parse(stored);
      return parsed.navigation || defaultValue;
    }
  } catch (error) {
    if (showLogs) {
      console.log(`Error loading ${key} from session storage:`, error);
    }
  }
  return defaultValue;
};

/**
 * Save agent context to session storage
 * @param {string} key - Storage key
 * @param {object} data - Data to save
 * @param {boolean} showLogs - Whether to show console logs
 */
export const saveToSessionStorage = (key, data, showLogs = false) => {
  try {
    const contextData = {
      navigation: data,
      timestamp: Date.now()
    };
    sessionStorage.setItem(key, JSON.stringify(contextData));
  } catch (error) {
    if (showLogs) {
      console.log(`Error saving ${key} to session storage:`, error);
    }
  }
};